import React from 'react';
import { Box, Typography } from '@mui/material';
import moment from 'moment';
import { Label } from 'src/components';
import { EnquiryHeaderComponent } from '.';
import { dateOfEnquiryLabelStyle, dateTimeTypoStyle, tableCellInnerBoxStyle } from '../../../../../styles/NewLeadTableRowStyle';

const CreatedAtDateCell = ({
    handleChangeDateFormat,
    showDate,
    handleNavigate,
    methods,
    setValue,
    dateFormat,
    formatData,
    typed,
}) => ({
        field: 'created_at',
        headerName: (
            <EnquiryHeaderComponent
                handleChangeDateFormat={handleChangeDateFormat}
                methods={methods}
                setValue={setValue}
            />
        ),
        width: 150,
        minWidth: 150,
        editable: false,
        renderCell: (params) => {
            const currentDate = moment().format('DD-MM-YYYY');
            return (
                <Box onClick={() => handleNavigate(params?.row)} sx={tableCellInnerBoxStyle}>
                    <Label
                        sx={dateOfEnquiryLabelStyle(formatData, params, currentDate, typed)}
                    >
                        <Typography
                            variant='05 Others/Label'
                            dangerouslySetInnerHTML={{ __html: showDate(dateFormat, params?.row) }}
                            sx={dateTimeTypoStyle}
                        />
                    </Label>
                </Box>
            );
        },
    });

export default CreatedAtDateCell;